import * as angular from 'angular';
import * as _ from "lodash";
import {BillingAccountsRequests} from "./billing-accounts-requests.service";
import {CommonsAlertsService} from "../../commons/services/commons-alerts.service";

export class BillingAccountActions {

  /* @ngInject */
  constructor(private billingAccountsRequests: BillingAccountsRequests, private $mdDialog, private billingAccountConstants,
              private $log, private splitService, private splitConstants) {
  }

  addPaymentMethod(event, billingAccountId) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/edit-billing-account-dialog.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: false,
      onComplete:(scope, element, options) => {
        var style = {
          base: { // Common to all input fields
            lineHeight: '30px',
            fontWeight: 400,
            fontSize: '13px',
            height: 'auto',
            // border: 'none',
            borderTop: 'none',
            borderRight: 'none',
            borderLeft: 'none',
            borderBottom: '1px groove',

            // Here you can style the span element that wraps the secure fields.
            // The default values are shown below.
            secureFields: {
              position: 'absolute',
              top:0
            },

            // The Primary Account Number (PAN) field is always included in the form.
            // You can style it here.
            pan: {
              marginRight: '10px'
            },

            // The expirationDate field is always included in the form.
            // You can style it here.
            expirationDate: {
              marginRight: '10px'
            },

            // Unless you disable the cvv field, it will be included in the form.
            // You can style it here.
            cvv: {

            }
          }
        };
        // POS.setStyle(style);
        // POS.initSecureFields('card-secure-fields');
        scope.loading = false;
      },
      controller:function ($scope) {

        $scope.country = self.splitService.getCountryCode();
        $scope.billingAccountId = billingAccountId;
        $scope.loading = true;
        $scope.validationError = undefined;
        $scope.payload = {
          identity_document: {
            number: undefined
          },
          billing_address: {

          }
        };

        if ($scope.country === 'US') {
          $scope.states = self.splitConstants.states;
          $scope.payload.billing_address.country = 'USA';
        }

        $scope.cancel = self.$mdDialog.cancel;
        $scope.onSubmit = onSubmit;

        function onSubmit(form) {
          form.$setSubmitted(true);
          if (form.$valid) {
            // _createToken($scope.payload);
          }
        }

      }
    });

  }

  exportBillingTransactions(event, billingAccountId) {

    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/billing-export-transactions-dialog.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      controller:function ($scope, commonsAlertsService: CommonsAlertsService, moment) {

        $scope.loading = false;

        $scope.cancel = self.$mdDialog.cancel;
        //////////////////////////////////////////////////////////////////////////////////////////////


        $scope.payload = {
          from: moment().startOf('month').toDate(),
          to: new Date()
        };

        $scope.submitForm = (form) => {

          if (form.$valid) {
            if (billingAccountId) {
              if (_.get($scope, 'payload')) {

                $scope.payloadCopy = angular.copy($scope.payload);

                var startOfFrom = moment($scope.payload.from).startOf('day'),
                  endOfTo = moment($scope.payload.to).endOf('day');

                $scope.payloadCopy.from = startOfFrom._d.getTime();
                $scope.payloadCopy.to = endOfTo._d.getTime();

                $scope.loading = true;
                self.billingAccountsRequests.exportTransactions(billingAccountId, $scope.payloadCopy)
                  .then(() => {
                    commonsAlertsService.exportToMailSuccess();
                    self.$mdDialog.hide();
                  })
                  .catch((error) => {
                    commonsAlertsService.exportToMailError();
                    self.$log.error('exporting billing has failed,' +
                      ' BillingAccountActions@exportBillingTransactions@submitForm \n' + error);
                    self.$mdDialog.cancel();
                  })
                  .finally(function () {
                  $scope.loading = false;
                });
              }
              else {
                self.$log.error('Payload resolved to undefined!. \n ' +
                  '--> exportBillingTransactions@submitForm');
              }
            }
            else {
              self.$log.error('billingAccountId resolved to undefined!. \n ' +
                '--> billingAccountId@submitForm');
            }
          }
          else {
            form.$setSubmitted(true);
          }
        }
      }
    })
  }

  charge(event, billingAccountId) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialog-views/charge-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      controller:function ($scope, $billingAccounts) {

        $scope.loading = false;
        var paymentMethodExist = false;

        $scope.cancel = self.$mdDialog.cancel;
        // ******************************
        //        External methods
        // ******************************

        $billingAccounts(billingAccountId).$asyncValue()
          .then((billingAccount) => {
            if (billingAccount) {
              paymentMethodExist = _.has(billingAccount, 'defaultPaymentMethod');
            }
          })
          .catch((error) => {
            self.$log.error('Failed to get Billing Account, @chargeDialog \n' + error);
          })

        $scope.submitForm = (form) => {

          if (form.$valid) {
            if (paymentMethodExist) {

              if (billingAccountId) {
                $scope._doUpdate();

              } else {
                self.$log.error('Payload resolved to undefined!. \n ' +
                  '--> createInvoice@submitForm');
              }


            } else {
              form.chargeAmount.$setValidity('valid', false);
            }

          } else {
            form.$setSubmitted(true);
          }

        }

        $scope._doUpdate = () => {
          $scope.loading = true;
          self.billingAccountsRequests.charge(billingAccountId, $scope.payload)
            .then(() => {
              self.$mdDialog.hide();
            })
            .catch((error) => {
              self.$log.error('Charge billing account failed at,' +
                ' BillingAccountActions@charge@doUpdate \n' + error);
              self.$mdDialog.cancel();
            })
            .finally(() => {
            $scope.loading = false;
          });
        }
      }
    })
  }

  addCredit(event, billingAccountId) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialog-views/add-credit-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      controller:function ($scope) {

        $scope.loading = false;

        $scope.cancel = self.$mdDialog.cancel;
        // ******************************
        //        External methods
        // ******************************

        $scope.submitForm = (form) => {

          if (form.$valid) {

            if (billingAccountId) {
              $scope._doUpdate();

            } else {
              self.$log.error('Payload resolved to undefined!. \n ' +
                '--> createInvoice@submitForm');
            }

          } else {
            form.$setSubmitted(true);
          }

        }

        $scope._doUpdate = () => {
          $scope.loading = true;
          self.billingAccountsRequests.addCredit(billingAccountId, $scope.payload)
            .then(() => {
              self.$mdDialog.hide();
            })
            .catch((error) => {
              self.$log.error('Add Credit in billing account failed at,' +
                ' BillingAccountActions@addCredit@doUpdate \n' + error);
              self.$mdDialog.cancel();
            })
            .finally(() => {
              $scope.loading = false;
            });
        }
      }
    })
  }

  addDebit(event, billingAccountId) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialog-views/add-debit-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      controller:function ($scope) {

        $scope.loading = false;

        $scope.cancel = self.$mdDialog.cancel;
        // ******************************
        //        External methods
        // ******************************

        $scope.submitForm = (form) => {

          if (form.$valid) {

            if (billingAccountId) {
              $scope._doUpdate();

            } else {
              self.$log.error('Payload resolved to undefined!. \n ' +
                '--> createInvoice@submitForm');
            }

          } else {
            form.$setSubmitted(true);
          }

        }

        $scope._doUpdate = () => {
          $scope.loading = true;
          self.billingAccountsRequests.addDebit(billingAccountId,$scope.payload)
            .then(() => {
              self.$mdDialog.hide();
            })
            .catch((error) => {
              self.$log.error('addDebt in billing account failed at,' +
                ' BillingAccountActions@addDebt@doUpdate \n' + error);
              self.$mdDialog.cancel();
            })
            .finally(function () {
            $scope.loading = false;
          });
        }

      }
    })
  }

  createInverc(event, billingAccountId) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialog-views/create-inverc-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      controller:function ($scope) {

        $scope.loading = false;

        $scope.cancel = self.$mdDialog.cancel;
        // ******************************
        //        External methods
        // ******************************

        $scope.paymentMethods = self.billingAccountConstants.paymentMethods;

        $scope.cards = self.billingAccountConstants.cardTypes;

        $scope.payload = {
          paymentMethod: {
            type: 'cash'
          }
        };

        var paymentSelected = 'cash';

        $scope.selectedPaymentMethod = function(newSelection) {
          if (!_.isUndefined(newSelection) && !_.isEqual(newSelection, paymentSelected)) {
            paymentSelected = newSelection;
            $scope.payload.paymentMethod = {
              type: newSelection
            }
          }
        };

        $scope.submitForm = (form) => {

          if (form.$valid) {

            if (billingAccountId) {
              var payloadCopy = angular.copy($scope.payload);

              if (_.isEqual($scope.payload.paymentMethod.type, 'cheque')) {
                payloadCopy.paymentMethod.chequeDate = payloadCopy.paymentMethod.chequeDate.getTime();
              }

              $scope._doUpdate(payloadCopy);

            } else {
              self.$log.error('Billing id resolved to undefined!. \n ' +
                '--> createInvoice@submitForm');
            }

          } else {
            form.$setSubmitted(true);
          }

        }

        $scope._doUpdate = (payloadCopy) => {
          $scope.loading = true;
          self.billingAccountsRequests.createInverc(billingAccountId, payloadCopy)
            .then(() => {
              self.$mdDialog.hide();
            })
            .catch((error) => {
              self.$log.error('createInverc in billing account failed at,' +
                ' BillingAccountActions@createInverc@doUpdate \n' + error);
              self.$mdDialog.cancel();
            })
            .finally(function () {
              $scope.loading = false;
            });
        }

      }
    })
  }

  createInvoice(event, billingAccountId) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialog-views/create-invoice-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      controller:function ($scope) {

        $scope.loading = false;

        $scope.cancel = self.$mdDialog.cancel;
        // ******************************
        //        External methods
        // ******************************

        $scope.submitForm = (form) => {
          if (form.$valid) {

            if (billingAccountId) {
              $scope._doUpdate();

            } else {
              self.$log.error('Payload resolved to undefined!. \n ' +
                '--> createInvoice@submitForm');
            }

          } else {
            form.$setSubmitted(true);
          }
        }

        $scope._doUpdate = () => {
          $scope.loading = true;
          self.billingAccountsRequests.createInvoice(billingAccountId, $scope.payload)
            .then(() => {
              self.$mdDialog.hide();
            })
            .catch((error) => {
              self.$log.error('createInvoice in billing account failed at,' +
                ' BillingAccountActions@createInvoice@doUpdate \n' + error);
              self.$mdDialog.cancel();
            })
            .finally(() => {
              $scope.loading = false;
            });
        }
      }
    })
  }

  createReceipt(event, billingAccountId) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialog-views/create-receipt-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      controller:function ($scope) {

        $scope.loading = false;
        $scope.cancel = self.$mdDialog.cancel;
        // ******************************
        //        External methods
        // ******************************

        $scope.showNicui = self.splitService.getCountryCode() === 'IL';
        $scope.paymentMethods = self.billingAccountConstants.paymentMethods;

        $scope.cards = self.billingAccountConstants.cardTypes;

        $scope.payload = {
          paymentMethod: {
            type: 'cash'
          }
        };

        var paymentSelected = 'cash';

        $scope.selectedPaymentMethod = (newSelection) => {
          if (!_.isUndefined(newSelection) && !_.isEqual(newSelection, paymentSelected)) {
            paymentSelected = newSelection;
            $scope.payload.paymentMethod = {
              type: newSelection
            }
          }
        };

        $scope.submitForm = (form) => {

          if (form.$valid) {

            if (billingAccountId) {

              var payloadCopy = angular.copy($scope.payload);

              if (_.isEqual($scope.payload.paymentMethod.type, 'cheque')) {
                payloadCopy.paymentMethod.chequeDate = $scope.payload.paymentMethod.chequeDate.getTime();
              }

              $scope._doUpdate(payloadCopy);

            } else {
              self.$log.error('Payload resolved to undefined!. \n ' +
                '--> createInvoice@submitForm');
            }

          } else {
            form.$setSubmitted(true);
          }

        }

        $scope._doUpdate = (payloadCopy) => {
          $scope.loading = true;
          self.billingAccountsRequests.createReceipt(billingAccountId, payloadCopy)
            .then((test) => {
              self.$mdDialog.hide();
            })
            .catch((error) => {
              self.$log.error('createReceipt in billing account failed at,' +
                ' BillingAccountActions@createReceipt@doUpdate \n' + error);
              self.$mdDialog.cancel();
            })
            .finally(function () {
            $scope.loading = false;
          });
        }
      }
    })
  }

  createDeal(event, billingAccountId) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialog-views/create-deal-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      controller:function ($scope) {

        $scope.loading = false;

        $scope.cancel = self.$mdDialog.cancel;
        // ******************************
        //        External methods
        // ******************************

        $scope.submitForm = (form) => {

          if (form.$valid) {

            if (billingAccountId) {
              $scope._doUpdate();

            } else {
              self.$log.error('Payload resolved to undefined!. \n ' +
                '--> createInvoice@submitForm');
            }

          } else {
            form.$setSubmitted(true);
          }

        }

        $scope._doUpdate = () => {
          $scope.loading = true;
          self.billingAccountsRequests.createDeal(billingAccountId, $scope.payload)
            .then(() => {
              self.$mdDialog.hide();
            })
            .catch((error) => {
              self.$log.error('createDeal in billing account failed at,' +
                ' BillingAccountActions@createDeal@doUpdate \n' + error);
              self.$mdDialog.cancel();
            })
            .finally(function () {
            $scope.loading = false;
          });
        }

      }
    })
  }

}

angular
  .module('bringoz.admin.billing-accounts')
  .service('billingAccountActions', BillingAccountActions);
